import apiClient from '../utils/apiClient';

export async function getEmployees(includeArchived = false) {
  const params = includeArchived ? '?include=archived' : '';
  const response = await apiClient.get(`/api/employees${params}`);
  return response.data;
}

export async function inviteEmployee(form) {
  try {
    const response = await apiClient.post('/api/employees/invite', form);
    return response.data;
  } catch (err) {
    const message = err.response?.data?.error || err.response?.data?.message || err.message || 'Failed to send invite.';
    throw new Error(message);
  }
}

export async function cancelInvite(inviteId) {
  const response = await apiClient.delete(`/api/employees/invite/${inviteId}`);
  return response.data;
}

export async function fetchJobTitles() {
  try {
    const response = await apiClient.get('/api/employees/job-titles');
    return response.data;
  } catch (err) {
    console.error("Failed to load job titles", err);
    throw err;
  }
}

export async function createJobTitle(name) {
  const response = await apiClient.post('/api/employees/job-titles', { name });
  return response.data;
}

// The route is keyed by the login account (users.user_id), not the employee row the list calls user_id.
export async function updateEmployee(employee) {
  const response = await apiClient.put(`/api/employees/${employee.account_user_id}`, employee);
  return response.data;
}

export async function batchUpdateEmployees(body) {
  const response = await apiClient.patch('/api/employees/batch', body);
  return response.data;
}

export async function resendInvites(ids) {
  const response = await apiClient.post('/api/employees/invites/resend', { ids });
  return response.data;
}

export async function getDepartments() {
  const response = await apiClient.get('/api/employees/departments');
  return response.data;
}

export async function createDepartment(name) {
  const response = await apiClient.post('/api/employees/departments', { name });
  return response.data;
}

export async function deleteEmployee(userId) {
  const response = await apiClient.delete(`/api/employees/${userId}`);
  return response.data;
}

export async function archiveEmployee(userId) {
  const response = await apiClient.patch(`/api/employees/${userId}/archive`);
  return response.data;
}

export async function restoreEmployee(userId) {
  const response = await apiClient.patch(`/api/employees/${userId}/restore`);
  return response.data;
}

export async function getProjectsForEmployee(employeeId) {
  const response = await apiClient.get(`/api/employees/${employeeId}/projects`);
  return response.data;
}

// Upload avatar for an employee
export async function uploadEmployeeAvatar(userId, file) {
  const formData = new FormData();
  formData.append('avatar', file);

  const response = await apiClient.post(`/api/employees/${userId}/avatar`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

// Get all available permissions grouped by category
export async function getAllPermissions() {
  try {
    const response = await apiClient.get('/api/permissions/by-category');
    return response.data;
  } catch (err) {
    console.error("Failed to load permissions", err);
    throw err;
  }
}

// Placeholder (ghost) employee services
export async function createPlaceholderEmployee(data) {
  const response = await apiClient.post('/api/employees/placeholder', data);
  return response.data;
}

export async function updatePlaceholderEmployee(employee_id, data) {
  const response = await apiClient.put(`/api/employees/placeholder/${employee_id}`, data);
  return response.data;
}

export async function deletePlaceholderEmployee(employee_id) {
  const response = await apiClient.delete(`/api/employees/placeholder/${employee_id}`);
  return response.data;
}